import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';

export function getRiderIdentifier(rider: ProductDataRider): string {
    return rider.typeCode ?? rider.riderGuid;
}
